interface JWTPayload {
  sub: number;
  email: string;
  role: string;
  permissions: string[];
  companyId: number;
  groupId: number | null;
  products: string[];
  accessGroups: string[];
  spaces: number[];
  iat: number;
  exp: number;
}

export const decodeJWT = (token: string): JWTPayload | null => {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) {
      console.error("Token JWT inválido: formato incorreto");
      return null;
    }

    const payload = parts[1];
    const decodedPayload = atob(payload);

    return JSON.parse(decodedPayload);
  } catch (error) {
    console.error("Erro ao decodificar JWT:", error);
    return null;
  }
};

export const isTokenExpired = (token: string): boolean => {
  const payload = decodeJWT(token);
  if (!payload) return true;

  const currentTime = Math.floor(Date.now() / 1000);
  return payload.exp < currentTime;
};

export const getUserCompanyId = (token: string): number | null => {
  const payload = decodeJWT(token);
  return payload?.companyId || null;
};

export const getUserPermissions = (token: string): string[] => {
  const payload = decodeJWT(token);
  return payload?.permissions || [];
};

export const getUserEmail = (token: string): string | null => {
  const payload = decodeJWT(token);
  return payload?.email || null;
};

export const getUserId = (token: string): number | null => {
  const payload = decodeJWT(token);
  return payload?.sub || null;
};

export const hasPermission = (token: string, permission: string): boolean => {
  const permissions = getUserPermissions(token);
  return permissions.includes(permission);
};
